<template>
  <v-layout
      v-if="photoList && photoList.length > 0"
      class="post-photos"
      row
      wrap>
    <v-container fluid grid-list-sm pa-2>
      <v-layout row wrap>
        <v-flex
            v-for="(photo, index) in photoSet"
            :key="`post_photo_${index}`"
            d-flex
            data-qe-id="post_enlarge_photo_link"
            v-bind="{[`xs${columns(photoSet)}`]: true}"
            @click="enlargePhotoHandler(index)">
          <v-card :class="photoCardStyles" flat
                  tile>
            <YpoImageWithLoader
                :data-qe-id="`post_photo_${index}`"
                :image-url="formattedPhotoUrl(photo.url, photoSet.length)">
            </YpoImageWithLoader>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex v-for="(photo, index) in videoSet" :key="`post_photo_${index}`"
                d-flex
                v-bind="{[`xs${columns(videoSet)}`]: true}">
          <video controls width="100%">
            <source :src="sanitizeVideoUrl(photo.url)" type="video/mp4">
          </video>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import { appCommonConstants } from "../../appCommon.constants";
import {
  sanitizeVideoUrl,
  sizeFormattedImageUrl,
  sizeFormattedImageUrlWithFaceFocused,
} from "@/common/utils/cloudinaryUtils";
import IconYpoWhite from "@/components/Icons/IconYpoWhite.vue";
import YpoImageWithLoader from "@/components/YpoImageWithLoader/YpoImageWithLoader.vue";

export default {
  name: 'PostPhotos',
  components: { YpoImageWithLoader, IconYpoWhite },
  props: {
    photoList: {
      type: Array,
      required: true,
    },
    enlargePhotoHandler: {
      type: Function,
      default: null,
    },
  },
  data: () => {
    return {
      appCommonConstants,
      sanitizeVideoUrl,
      sizeFormattedImageUrl,
    };
  },
  computed: {
    photoSet() {
      return this.photoList && this.photoList.length ? this.photoList.filter(item => this.isImageType(item.mediaType)) : null;
    },
    videoSet() {
      return this.photoList && this.photoList.length ? this.photoList.filter(item => this.isVideoType(item.mediaType)) : null;
    },
    photoCardStyles() {
      let classes = 'd-flex post-photos__image-card';
      if (this.photoSet.length > 1 && this.photoSet.length < 5) {
        classes = `${classes} post-photos__image-card--4x-multi`;
      } else if (this.photoSet.length > 4) {
        classes = `${classes} post-photos__image-card--6x-multi`;
      }
      return classes;
    },
  },
  methods: {
    columns(assetSet) {
      //calculating grid columns based on number of photos
      if (assetSet && assetSet.length) {
        // eslint-disable-next-line no-nested-ternary
        return (assetSet.length >= 2 && assetSet.length < 5) ?
            6 :
            assetSet.length < 2 ?
                12 :
                4;
      }
    },
    isImageType(type) {
      return new RegExp(`${this.appCommonConstants.IMAGE_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
    },
    isVideoType(type) {
      return new RegExp(`${this.appCommonConstants.VIDEO_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
    },
    formattedPhotoUrl(url, totalPhotos) {
      if (totalPhotos && url) {
        if (totalPhotos === 1) {
          return sizeFormattedImageUrl(url, 900);
        } else if (totalPhotos > 1 && totalPhotos < 5) {
          return sizeFormattedImageUrlWithFaceFocused(url, 600, 900);
        }
        return sizeFormattedImageUrlWithFaceFocused(url, 300, 500);
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import '../../../common/styles/_colors.scss';
@import "../../../common/styles/_responsive.scss";

.post-photos {
  cursor: pointer;

  &__image-card {
    max-height: 400px;
    position: relative;

    @include breakpointMin(sm) {
      max-height: 600px;
      min-height: 400px;
    }

    .v-image__image--cover {
      background-size: contain;
    }

    &--4x-multi {
      height: 115px;
      min-height: 115px;

      @include breakpointMin(sm) {
        height: 200px;
      }

      @include breakpointMin(md) {
        height: 260px;
      }

      .v-image__image--cover {
        background-size: cover;
      }
    }

    &--6x-multi {
      height: 80px;
      min-height: 80px;

      @include breakpointMin(sm) {
        height: 150px;
      }

      @include breakpointMin(md) {
        height: 200px;
      }

      .v-image__image--cover {
        background-size: cover;
      }
    }
  }

  &--placeholder {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $ypo-light-gray;
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 25%, rgba(200, 200, 200, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
      animation: shimmer 2s infinite linear;
    }
  }

  @keyframes shimmer {
    100% {
      left: 100%;
    }
  }
}
</style>
